import React, { memo, forwardRef } from "react";
const SvgCapitalIota = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.376 8.344v14.688c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V8.344c0-.496.128-.84.384-1.032.256-.208.528-.312.816-.312.272 0 .536.104.792.312.256.192.384.536.384 1.032z"
      />
    </svg>
  );
});
SvgCapitalIota.displayName = "SvgCapitalIota";
const MemoForwardRef = memo(SvgCapitalIota);
export default MemoForwardRef;
